import { connect } from 'react-redux';

import { selectors as createSelectors } from 'dux/createInstance';
import { actionCreators as clickTrackerActionCreators } from 'dux/clickTracker';
import FormSelect from './FormSelect';

function mapStateToProps(state) {
  return {
    availableServiceSubtypesNames: createSelectors.availableServiceSubtypesNamesSelector(state),
    availableCloudProviders: createSelectors.availableCloudProvidersSelector(state),
    availableRegionsNames: createSelectors.availableRegionsNamesSelector(state),
    selectedRegion: createSelectors.selectedRegionSelector(state),
    isPrivateRegion: createSelectors.isPrivateRegionSelector(state),
    selectedService: createSelectors.selectedServiceSelector(state),
  };
}

const mapDispatchToProps = {
  trackButtonClick: clickTrackerActionCreators.trackButtonClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormSelect);
